export const API_ENDPOINT = 'https://api.rtvhit.com';

//export const API_ENDPOINT = 'http://localhost:33101';